import { Box, Typography } from "@mui/material";
import { ValidatedTextInput } from "../../../common/inputs/ValidatedInputs";
import { OrdinaryButton } from "../../../common/Buttons";
import { useFormValidator } from "../../../common/inputs/useFormValidator";
import { useState } from "react";
import { useAuthentication } from "../../../common/hooks/useAuthentication";
import { useFormStatus } from "../../../common/inputs/useFormStatus";

const defaultLoginForm = {
    username: '',
    password: ''
}

const LoginForm = ({ onSuccess, onError }) => {
    const [valid, setFieldValidity, resetValid, fieldsValidity, formChanged, onFieldChange] = useFormValidator();// eslint-disable-line no-unused-vars
    const [status, setStatus, statusCodes] = useFormStatus();

    const [loginForm, setLoginForm] = useState(defaultLoginForm);

    const { login } = useAuthentication();

    const onChange = (id, value, valid) => {
        setFieldValidity(id, valid);

        if (loginForm[id] !== value) {
            let newLoginForm = {
                ...loginForm
            };
            newLoginForm[id] = value;
            setLoginForm(newLoginForm);
            onFieldChange();
        }
    }

    const onSubmit = async (evt) => {
        evt.preventDefault();

        setStatus(statusCodes.SAVING);
        try {
            await login(loginForm);
            onSuccess && onSuccess();
        } catch (error) {
            console.error(error);
            setStatus(statusCodes.AWAITING_USER_INPUT);
            onError(error);
        }
    }

    return <>
        <Box sx={{ margin: '30px', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <Typography variant="h6">Please enter your username and password:</Typography>
            <form style={{ display: 'flex', flexDirection: 'column' }}>
                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '50px' }}>
                    <ValidatedTextInput
                        value={loginForm.username}
                        label='Username'
                        size='small'
                        autoFocus
                        margin="dense"
                        id="username"
                        type="text"
                        required
                        onChange={onChange}
                        disabled={status === status.SAVING}
                        disableError={!formChanged}
                        sx={{
                            width: '300px'
                        }}
                    />
                    <ValidatedTextInput
                        value={loginForm.password}
                        label='Password'
                        size='small'
                        margin="dense"
                        id="password"
                        type="password"
                        onChange={onChange}
                        disabled={status === status.SAVING}
                        disableError={!formChanged}
                        sx={{
                            width: '300px'
                        }}
                    />
                </Box>
                <OrdinaryButton
                    type='submit'
                    text='Login'
                    onClick={onSubmit}
                    disabled={!valid}
                    loading={status === statusCodes.SAVING}
                    sx={{ width: '300px' }}
                />
            </form>
        </Box>
    </>
}

export default LoginForm;